import { forwardRef, useRef, useState, useEffect } from 'react';
import _ from 'lodash';
import I18n from '@/rI18n';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';

import CloseIcon from '@material-ui/icons/Close';
import BookmarkList from './BookmarkList';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import CircularProgress from '@material-ui/core/CircularProgress';

const BookmarkPopup = forwardRef(
    ({
        bookmarkPopupContainerClassName='',
        ticketKnowledge,
        handleCloseBookmarkPopup,
        isDisplayBookmarkList,
        setIsDisplayBookmarkList,

        taggedBookmarkList,
        setTaggedBookmarkList,
        listBookmarkCompare,
        listBookmark,
        setListBookmark,
        filteredSuggestions,
        setFilteredSuggestions,

        onChangeSubmitData,
        setOnChangeSubmitData,

        editNameError,
        setEditNameError,

        setIsShowDialogConfirmDuplicateShareBookmark,

        userDetail,
        projectInuseDetail,
        isProjectManager,
        mobilePopupMarginLeft,
        isLoadingBookmark,
        handleSubmitEditBookmark,

        isShowDialogConfirmSubmitData
    }, ref) => {
    
    const bookmarkTaggedTicketRef = useRef(null)
    const createNewInputRef = useRef(null);
    const bookmarkRefs = useRef([]);
    const [createNewInput, setCreateNewInput] = useState('')
    
    const handleAddTagBookmark = (bookmarkName, isAddNew = false, selectedBookmarkId = '') => {
        if (!bookmarkName) return;
        const newBookmarkName = bookmarkName.trim();
        if (newBookmarkName.length === 0) {
            setCreateNewInput('')
            setFilteredSuggestions([])
            return
        }
        
        const myExistBookmark = taggedBookmarkList.find(b => b.creator === userDetail.id && b.name === newBookmarkName)
        const userExistBookmark = taggedBookmarkList.find(b => b.creator !== userDetail.id && b.name === newBookmarkName)

        if (myExistBookmark && userExistBookmark) {
            setCreateNewInput('')
            setFilteredSuggestions([])
            return
        }
        
        let newBookmark;
        if (isAddNew) {
            const createdBookmark = listBookmark.find(b => b.creator === userDetail.id && b.name === newBookmarkName)
            if (!createdBookmark) {
                newBookmark = {
                    id: `temp_${Date.now()}`,
                    definition: 'USER',
                    name: newBookmarkName,
                    defaultBookmark: '',
                    shareRange: userDetail.id,
                    creator: userDetail.id,
                    isTagged: true,
                    createdAt: new Date().toISOString(),
                    isCanDelete: true,
                    isCanUnshare: true
                }
            }
        }

        if (!newBookmark) {
            let existedBookmark = selectedBookmarkId
                ? listBookmark.find(b => b.name === bookmarkName && !b.isTagged && b.id === selectedBookmarkId)
                : filteredSuggestions.find(b => b.name === bookmarkName && !b.isTagged && b.shareRange === userDetail.id)
                    || filteredSuggestions.find(b => b.name === bookmarkName && !b.isTagged && b.shareRange !== userDetail.id);

            if (existedBookmark) {
                newBookmark = {
                    ...existedBookmark,
                    isTagged: true
                }
            }
        }
        
        if (!newBookmark) {
            setCreateNewInput('')
            setFilteredSuggestions([])
            return
        }

        setTaggedBookmarkList(prev => [...prev, newBookmark])
        setListBookmark(prev => {
            if (prev.some(b => b.id === newBookmark.id)) {
                return [...prev.map(b => {
                    if (b.id === newBookmark.id) {
                        return {...newBookmark}
                    }
                    return b
                })]
            } else {
                return [...prev, newBookmark]
            }
        })

        setOnChangeSubmitData(prev => {
            const prefix = Utils.getPrefixOfId(newBookmark.id);
            if (prefix === Constant.BOOKMARK_PREFIX.TEMP) {
                let addNewData = [...prev.addNew]
                if (addNewData.some(b => b.id === newBookmark.id)) addNewData = addNewData.filter(b => b.id !== newBookmark.id)
                return {
                    ...prev,
                    addNew: [...addNewData, newBookmark]
                }
            }

            let editData = [...prev.edit]
            if (editData.some(b => b.id === newBookmark.id)) editData = editData.filter(b => b.id !== newBookmark.id)
            return {
                ...prev,
                edit: [...editData, newBookmark]
            }
        })
        setFilteredSuggestions([])
        setCreateNewInput('')
    }

    const handleCancelTaggedBookmark = (bookmark) => {
        setTaggedBookmarkList(prev => [...prev.filter((b) => b.id !== bookmark.id)]);
        setListBookmark(prev => [...prev.map(b => {
            if (b.id === bookmark.id) {
                return {
                    ...b,
                    isTagged: false
                }
            }
            return b
        })])
        setOnChangeSubmitData(prev => {
            const prefix = Utils.getPrefixOfId(bookmark.id);
            if (prefix === Constant.BOOKMARK_PREFIX.TEMP) {
                return {
                    ...prev,
                    addNew: [...prev.addNew.map(b => {
                        if (b.id === bookmark.id) {
                            return {
                                ...b,
                                isTagged: false
                            }
                        }
                        return b
                    })]
                }
            }

            const editList = [...prev.edit]
            if (!editList.some(b => b.id === bookmark.id)) {
                return {
                    ...prev,
                    edit: [...editList, {...bookmark, isTagged: false}]
                }
            }

            const compareBookmark = listBookmarkCompare.find(b => b.id === bookmark.id)
            const isChanged = !_.isEqual(compareBookmark, {...bookmark, isTagged: false})
            if (isChanged) {
                return {
                    ...prev,
                    edit: [...prev.edit.map(b => {
                        if (b.id === bookmark.id) {
                            return {
                                ...b,
                                isTagged: false
                            }
                        }
                        return b
                    })]
                }
            }
            return {
                ...prev,
                edit: [...prev.edit.filter(b => b.id !== bookmark.id)]
            }
        })
    }

    const handleSelectSuggest = (selectedSuggest) => {
        const isExistBookmark = taggedBookmarkList.find(tagged => tagged.id === selectedSuggest.id);
        if (isExistBookmark) {
            const container = bookmarkTaggedTicketRef.current;
            if (container && container.offsetHeight >= 110 ) {
                // handle scroll to bookmark
                const index = taggedBookmarkList.findIndex(tagged => tagged.id === selectedSuggest.id);
                if (index !== -1 && bookmarkRefs.current[index]) {
                    bookmarkRefs.current[index].scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            }
            setCreateNewInput('')
            setFilteredSuggestions([])
        } else {
            handleAddTagBookmark(
                selectedSuggest.name,
                false,
                selectedSuggest.id
            )
        }
    }

    const handleInputChange = (e) => {
        const value = e.target.value;
        if (value.length > 100) return;
        
        if (value) {
            setCreateNewInput(value);
            const filtered = [...listBookmark]
                .filter((item) => item.name.includes(value))
                .map(item => {
                    const isTagged = taggedBookmarkList.some(tagged => tagged.id === item.id);
                    return {
                        ...item,
                        isTagged
                    };
                });
            setFilteredSuggestions([...filtered]);
        } else {
            setCreateNewInput('')
            setFilteredSuggestions([]);
        }
    };

    // handle listenEvent scroll to bottom
    // useEffect(() => {
    //     if (Utils.isEmptyArray(taggedBookmarkList)) return;

    //     const container = bookmarkTaggedTicketRef.current;
    //     if (container && container.offsetHeight >= 110 ) {
    //         container.scrollTop = container.scrollHeight;
    //     }
    // }, [taggedBookmarkList]);

    // handle tagged bookmark item in list to scroll
    useEffect(() => {
        if (!Utils.isEmptyArray(taggedBookmarkList)) {
            bookmarkRefs.current = bookmarkRefs.current.slice(0, taggedBookmarkList.length);
        }
    }, [taggedBookmarkList]);
    
    const [isComposing, setIsComposing] = useState(false);

    return (
        <div className={`bookmark-popup-container ${bookmarkPopupContainerClassName ? bookmarkPopupContainerClassName : ''}`} style={{marginLeft: `${mobilePopupMarginLeft}px`}} ref={ref}>
            {isLoadingBookmark ? (<CircularProgress color="primary" size="1.4rem"/>) : (
                <>
                    <div className='bookmark-header'>
                        <p className='bookmark-container-title'>{I18n.get('BOOKMARK_TAG_SETTING')}</p>
                        <CloseIcon
                            className='bookmark-container-close'
                            fontSize="inherit"
                            onClick={() => handleCloseBookmarkPopup(listBookmarkCompare, onChangeSubmitData, false, editNameError)}
                        />
                    </div>
                    {/* Bookmark Body */}
                    <div className='bookmark-body'>
                        {/* Tagged Bookmark List Container */}
                        <div className="tagged-bookmark-list-container" ref={bookmarkTaggedTicketRef}>
                            {taggedBookmarkList.length > 0 && (
                                <ul className="tagged-bookmark-list">
                                    {taggedBookmarkList?.map((bookmark, index) => (
                                        <li key={index} ref={(el) => (bookmarkRefs.current[index] = el)} className="tagged-bookmark">
                                            <OverFlowTooltipWithTabsMui
                                                className="tagged-bookmark-title"
                                                value={bookmark.name}
                                            />
                                            <img
                                                src='/assets/image/icon-chip-close.svg'
                                                alt='icon-close'
                                                className='tagged-bookmark-close-icon'
                                                onClick={() => handleCancelTaggedBookmark(bookmark)}
                                            />
                                        </li>
                                    ))}
                                </ul>
        
                            )}
                            <input
                                className="add-new-bookmark-input"
                                ref={createNewInputRef}
                                value={createNewInput}
                                onChange={(e) => handleInputChange(e)}
                                onCompositionStart={() => setIsComposing(true)}
                                onCompositionEnd={(e) => {
                                    setIsComposing(false);
                                    handleInputChange(e);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !isComposing) {
                                        handleAddTagBookmark(e.target.value, true);
                                    }
                                }}
                            />
        
                            <span className='rectangle' />
                            <img src="/assets/image/icon-chevron-down.svg" alt='chevron-down' className='drop-down' onClick={() => setIsDisplayBookmarkList(!isDisplayBookmarkList)}/>
        
                        </div>
                        {/* Suggestion Container */}
                        {(!Utils.isEmptyArray(filteredSuggestions) || !Utils.isEmptyString(createNewInput)) && (
                            <div className='bookmark-suggest-list'>
                                {(
                                    !Utils.isEmptyString(createNewInput) &&
                                    filteredSuggestions
                                        .filter(f => f.creator === userDetail.id)
                                        .every(f => f.name !== createNewInput)
                                ) && (
                                    <p className='bookmark-suggest-add' onClick={() => handleAddTagBookmark(createNewInput, true)}>
                                        <img src='/assets/image/icon-add-plus-blue.svg' alt='icon-add' />
                                        <span className='bm-add-more'>{`${createNewInput}${I18n.get('ADD_MORE')}`}</span>
                                    </p>
                                )}
                                {filteredSuggestions.filter(b => b.shareRange === userDetail.id)?.length > 0 &&
                                    <h4 className='title-bookmark-list'>{I18n.get('PRIVATE_BOOKMARK_TAG')}</h4>}
                                {filteredSuggestions.filter(b => b.shareRange === userDetail.id)?.map(suggest => (
                                    <p
                                        key={suggest.id}
                                        className={`bookmark-suggest-item ${suggest.isTagged && 'isTagged'}`}
                                        onClick={() => handleSelectSuggest(suggest)}
                                    >
                                        {suggest.name}
                                    </p>
                                ))}
                                {filteredSuggestions.filter(b => b.shareRange !== userDetail.id)?.length > 0 &&
                                    <h4 className='title-bookmark-list'>{I18n.get('SHARE_BOOKMARK_TAG')}</h4>}
                                {filteredSuggestions.filter(b => b.shareRange !== userDetail.id)?.map(suggest => (
                                    <p
                                        key={suggest.id}
                                        className={`bookmark-suggest-item ${suggest.isTagged && 'isTagged'}`}
                                        onClick={() => handleSelectSuggest(suggest)}
                                    >
                                        {suggest.name}
                                    </p>
                                ))}
                            </div>
                        )}
                        {/* Bookmark List Container */}
                        {isDisplayBookmarkList && (
                            <div className='list-bookmark'>
                                <div className='bookmark-notification'>
                                    <img className='icon-notification' src="/assets/image/icon-instruction-chat-ai.svg" alt="icon" />
                                    <span className='text-notification'>
                                        {I18n.get('CAN_ADD_MORE_THIS_PLACE')}
                                    </span>
                                </div>
                                <div className='list-bookmark-inner'>
                                    <BookmarkList
                                        listBookmark={listBookmark}
                                        setListBookmark={setListBookmark}
                                        setTaggedBookmarkList={setTaggedBookmarkList}
                                        setFilteredSuggestions={setFilteredSuggestions}
        
                                        userDetail={userDetail}
                                        projectInuseDetail={projectInuseDetail}
                                        isProjectManager={isProjectManager}
                                        
                                        handleAddTagBookmark={handleAddTagBookmark}
                                        setOnChangeSubmitData={setOnChangeSubmitData}
                                        editNameError={editNameError}
                                        setEditNameError={setEditNameError}
                                        setIsShowDialogConfirmDuplicateShareBookmark={setIsShowDialogConfirmDuplicateShareBookmark}

                                        isShowDialogConfirmSubmitData={isShowDialogConfirmSubmitData}
                                    />
                                </div>
                                <BookmarkPopupFooter
                                    handleCloseBookmarkPopup={handleCloseBookmarkPopup}
                                    onChangeSubmitData={onChangeSubmitData}
                                    listBookmarkCompare={listBookmarkCompare}
                                    editNameError={editNameError}
                                    handleSubmitEditBookmark={handleSubmitEditBookmark}
                                />
                            </div>
                        )}
                    </div>

                    {!isDisplayBookmarkList && (
                        <BookmarkPopupFooter
                            handleCloseBookmarkPopup={handleCloseBookmarkPopup}
                            onChangeSubmitData={onChangeSubmitData}
                            listBookmarkCompare={listBookmarkCompare}
                            editNameError={editNameError}
                            handleSubmitEditBookmark={handleSubmitEditBookmark}
                        />
                    )}
                </>
            )}
        </div>
    )
});

export default BookmarkPopup;

const BookmarkPopupFooter = ({
    handleCloseBookmarkPopup,
    onChangeSubmitData,
    listBookmarkCompare,
    editNameError,
    handleSubmitEditBookmark
}) => {
    const [isChangedSubmitData, setIsChangedSubmitData] = useState(false)

    useEffect(() => {
        let isChanged = false;
        if (!Utils.isEmptyString(editNameError)) {
            setIsChangedSubmitData(false)
            return
        };
        
        if (!Utils.isEmptyArray(listBookmarkCompare) && onChangeSubmitData && onChangeSubmitData.addNew && onChangeSubmitData.edit) {
            if (!Utils.isEmptyArray(onChangeSubmitData?.addNew)) {
                isChanged = true
            }

            let editData= [...onChangeSubmitData.edit]
            for (let i = 0; i < listBookmarkCompare.length; i++) {
                const initEditData = listBookmarkCompare[i]
                for (let y = 0; y < editData.length; y++) {
                    const edited = editData[y];
                    if (initEditData.id === edited.id) {
                        const isNotIsEqual = !_.isEqual(initEditData, edited)
                        if (isNotIsEqual) {
                            isChanged = true;
                            break;
                        }
                    }
                }
            }
        }
        setIsChangedSubmitData(isChanged)

        return () => {
            setIsChangedSubmitData(false)
        }
    }, [editNameError, onChangeSubmitData])

    return (
        <div className='bookmark-footer'>
            <btn className='btn-cancel-submit' onClick={() => handleCloseBookmarkPopup(listBookmarkCompare, onChangeSubmitData, false, editNameError)}>{I18n.get('COMBTN001')}</btn>
            <btn
                className={`btn-submit ${!isChangedSubmitData && 'disable'}`}
                onClick={() => {
                    if (!isChangedSubmitData) return;
                    handleSubmitEditBookmark()
                }}
            >
                {I18n.get('SAVE_AND_CLOSE')}
            </btn>
        </div>
    )
}
